/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CommonResponse { 
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
}

